import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-filter-search-multi-select',
  templateUrl: './filterSearchMultiSelect.component.html',
  styleUrls: ['./filterSearchMultiSelect.component.scss']
})
export class FilterSearchMultiSelectComponent implements OnInit {

 
  @Input() loggedInPermissionData: any[] = [];
  @Input() selectedPermissions: string[] = [];
  @Output() selectedPermissionsChange = new EventEmitter<string[]>();

  permissionControl = new FormControl([]);
  searchControl = new FormControl('');
  filteredPermissions: any[] = [];

  ngOnInit() {
    // Initializing the filtered permissions with the full list
    this.filteredPermissions = this.loggedInPermissionData;

    // Set up the search control to filter permissions
    this.searchControl.valueChanges
      .pipe(debounceTime(200), distinctUntilChanged())
      .subscribe((searchText: string) => {
        this.filteredPermissions = this.loggedInPermissionData.filter(
          permission =>
            permission.permission.toLowerCase().includes(searchText.toLowerCase()) || 
            permission.displayName.toLowerCase().includes(searchText.toLowerCase())
        );
      });

    // Update the selectedPermissions when the selection changes

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedPermissions && changes.selectedPermissions.currentValue) {
        this.permissionControl.setValue(
            this.loggedInPermissionData.filter(permission =>
                this.selectedPermissions.includes(permission.permission)
            )
        );
    }
  
    if (changes.loggedInPermissionData && changes.loggedInPermissionData.currentValue) {
        this.filteredPermissions = this.loggedInPermissionData;
        // Recalculate the selected permissions in case the logged-in data changes
        this.permissionControl.setValue(
            this.loggedInPermissionData.filter(permission =>
                this.selectedPermissions.includes(permission.permission)
            )
        );
    }
}


  onClose()
  {
    const selectedPermissions = this.permissionControl.value.map(permission => permission.permission);

    // Emit the selected permissions array
    this.selectedPermissionsChange.emit(selectedPermissions);
  
    // Optional: Log the selected permissions to the console
    // console.log(arr)
  }
  
}
